"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../services/images");
const react_select_1 = __importDefault(require("react-select"));
const react_1 = require("react");
const aircraftHandlers_1 = require("../../handlers/aircraftHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const react_i18next_1 = require("react-i18next");
const searchHelpers_1 = require("../../services/searchHelpers");
const AircraftDropdownWeb = (props) => {
    (0, react_1.useEffect)(() => {
        (0, aircraftHandlers_1.getPilotAircraftHandler)();
    }, []);
    const aircraftOptions = (0, react_redux_1.useSelector)(selectors_1.getPilotAircraft);
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'search' });
    return ((0, jsx_runtime_1.jsx)("div", { className: "group", children: (0, jsx_runtime_1.jsxs)("div", { className: "box", children: [(0, jsx_runtime_1.jsx)("img", { alt: "", src: images_1.icons.Airplane, className: "icon" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { classNamePrefix: "select", className: "select", onChange: props.onAircraftChange, placeholder: t("select_airplane"), value: props.aircraft ? (0, searchHelpers_1.mapAircraftToOption)(props.aircraft) : null, options: aircraftOptions.map(aircraft => (0, searchHelpers_1.mapAircraftToOption)(aircraft)), noOptionsMessage: ({ inputValue }) => !inputValue ? t("no_select") : "" })] }) }));
};
exports.default = AircraftDropdownWeb;
